'use client'

import { useEffect, useState } from 'react'
import { getProjects, Project } from '@/lib/api/project-client'
import { useActiveProject } from '@/contexts/ActiveProjectContext'

export function ProjectSwitcher() {
  const { activeProjectId, setActiveProject } = useActiveProject()
  const [projects, setProjects] = useState<Project[]>([])

  useEffect(() => {
    getProjects(0, 100).then((r) => setProjects(r.items)).catch(() => {})
  }, [])

  return (
    <select
      aria-label="Active project"
      value={activeProjectId ?? ''}
      onChange={(e) => setActiveProject(e.target.value)}
      title="Active project"
      className="max-w-[10rem] min-w-0 shrink truncate rounded border px-2 py-1 text-sm"
    >
      {projects.map((p) => (
        <option key={p.project_id} value={p.project_id}>
          {p.name}
        </option>
      ))}
    </select>
  )
}
